export enum Authority {
	ADMIN 		= { code: 0, description: 'USER.ADMIN' } as any,
	MANAGER 	= { code: 1, description: 'USER.MANAGER' } as any,
	ATTENDANT 	= { code: 2, description: 'USER.ATTENDANT' } as any,
	KITCHEN 	= { code: 3, description: 'USER.KITCHEN' } as any,
	// MASTER 		= { code: 5, description: 'USER.MASTER' } as any,
	DELIVERYMAN = { code: 6, description: 'USER.DELIVERYMAN' } as any
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/authority.enum.ts